// src/context/DashboardProvider.jsx
import React from "react";
import { WebProvider } from "./Dashboard/contextWeb";
import { NetworkProvider } from "./Dashboard/contextNetwork";
import { AwsConfigProvider } from "./Dashboard/aws/contextConfig";
import { AwsIpProvider } from "./Dashboard/aws/contextIp";
import { AwsUrlProvider } from "./Dashboard/aws/contextUrl";
import { AzureConfigProvider } from "./Dashboard/azure/contextConfig";
import { AzureIpProvider } from "./Dashboard/azure/contextIp";
import { AzureUrlProvider } from "./Dashboard/azure/contextUrl";
import { GcpConfigProvider } from "./Dashboard/gcp/contextConfig";
import { GcpIpProvider } from "./Dashboard/gcp/contextIp";
import { GcpUrlProvider } from "./Dashboard/gcp/contextUrl";
import { OciConfigProvider } from "./Dashboard/oci/contextConfig";
import { OciIpProvider } from "./Dashboard/oci/contextIp";
import { OciUrlProvider } from "./Dashboard/oci/contextUrl";
import { MalwareProvider } from "./Dashboard/contextMalware";
import { DarkwebProvider } from "./Dashboard/contextDarkweb";
import { AnalyticsProvider } from "./Dashboard/contextAnalytics";
import { TSProvider } from "./Dashboard/contextTScore";
import { NavProvider } from "./contextNav";
import { ReportsProvider } from "./Dashboard/contextReports";

export const DashboardProvider = ({ children }) => {
  const providers = [
    WebProvider,
    NetworkProvider,
    AwsConfigProvider,
    AwsIpProvider,
    AwsUrlProvider,
    AzureConfigProvider,
    AzureIpProvider,
    AzureUrlProvider,
    GcpConfigProvider,
    GcpIpProvider,
    GcpUrlProvider,
    OciConfigProvider,
    OciIpProvider,
    OciUrlProvider,
    MalwareProvider,
    DarkwebProvider,
    AnalyticsProvider,
    NavProvider,
    ReportsProvider,
    TSProvider,
  ];

  return providers.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    children
  );
};
